import { render } from "./FooterPage.vue?vue&type=template&id=78bb1660&scoped=true"
import script from "./FooterPage.vue?vue&type=script&lang=js"
export * from "./FooterPage.vue?vue&type=script&lang=js"

import "./FooterPage.vue?vue&type=style&index=0&id=78bb1660&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bb1660"]])

export default __exports__